import React from 'react';

import styles from './FontPreloader.module.scss';

const FontPreloader = () => {
  const fontsArray = [
    'font-display-large',
    'font-display-medium',
    'font-display-small',
    'font-headline-large',
    'font-headline-medium',
    'font-headline-small',
    'font-title-large',
    'font-title-medium',
    'font-title-small',
    'font-label-huge',
    'font-label-large',
    'font-label-medium',
    'font-label-small',
    'font-label-huge-prominent',
    'font-label-large-prominent',
    'font-label-medium-prominent',
    'font-label-small-prominent',
    'font-body-large',
    'font-body-medium',
    'font-body-small',
    'font-body-large-prominent',
    'font-body-medium-prominent',
    'font-body-small-prominent',
    'font-special-password',
  ];

  return (
    <div className={styles.container}>
      {fontsArray.map((font) => (
        <span className={styles[font]} key={font} aria-hidden />
      ))}
    </div>
  );
};

export default FontPreloader;
